import { render } from "./FavoritesPage.vue?vue&type=template&id=7ea14ed9&scoped=true&ts=true"
import script from "./FavoritesPage.vue?vue&type=script&lang=ts"
export * from "./FavoritesPage.vue?vue&type=script&lang=ts"

import "./FavoritesPage.vue?vue&type=style&index=0&id=7ea14ed9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea14ed9"]])

export default __exports__